import React, { Component } from 'react'
import { connect } from 'react-redux';
import { ROLES } from '../../constants/AuthConstants';
import redirectByRole from '../common/RedirectByRole';
import DefaultLayout from '../layout/default-layout';

class CatalogRoot extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { bc, children } = this.props;
    return (
      <DefaultLayout {...this.props} >
        {children}
      </DefaultLayout>
    );
  }
}

export default connect(null, {})(redirectByRole(CatalogRoot, [ROLES.ADMIN, ROLES.REPORT, ROLES.CLIENT, ROLES.SALESMAN]));
